export enum NavigationLayoutTypes {
    User = 1,
    Group = 2,
    Enterprise = 3,
    System = 4,
    Stored = 5
}
